module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av561-1381ac57a483f819ff716a9dc009e5bf.jpg";